import { Box, Grid, IconButton } from '@mui/material'
import { ViewIcon } from '../../../../core/global/Icons'
import { View } from './View'
import Currency from 'react-currency-format';
import moment from 'moment'
import { rqx } from '../../../../core/request/API';
import { env } from '../../../../core/Env';

export const Paid = ({openView, record, subdir, tool_state, paidView}) => {
    const header = ['Payment Date', 'Payment Reference', 'Total Paid Amount', 'Action']

    const handlerView = async(v) => {
        openView.set(true)
        paidView.set({...paidView.data, loader: true})
        const res = await rqx.get(`<<tool>>/${env()}/payment/viewPaid`, {id: v.paid_id, company_id: tool_state.__SESSION.data.uaccess[0].company_id, type: subdir})
        if (res) {
            const totalAmounts = res.list.reduce((total, item) => {
                return {
                    total_sales: total.total_sales + parseFloat(item.amount),
                }
            }, {total_sales: 0, total_fee: 0})
            paidView.set({...paidView.data, loader: false, list: res.list, total_sales: totalAmounts.total_sales, total_fees: res.total_fees, total_net_amount: res.total_net_amount, transfer_charges: res.transfer_charges, payment_reference_number: res.payment_reference_number, name: res.name, link: res.link, account_number: res.account_number, bank_name: res.bank_name})
            // paidView.set({...paidView.data, list: res.list, total_sales: totalAmounts.total_sales, total_fees: res.total_fees, total_net_amount: res.total_net_amount, transfer_charges: res.transfer_charges, payment_reference_number: res.payment_reference_number, name: res.name, link: res.link})
        }
       
    }
    
    return (
        <Box height="100%" width="100%" display="flex" flexDirection="column" gap="16px" className="overflowY">
            <Box height="100%" width="100%" display="flex" flexDirection="column" className="overflowY" >
                <Grid container bgcolor="#f2f2f2" borderBottom="1px solid #ddd" p={1} fontWeight={700} fontSize={14}>
                    {
                        header.map((v,k) => (
                            <Grid item md={3} key={k} textAlign="center">
                                {v}
                            </Grid>
                        ))
                    }
                </Grid>
                <Box height="100%" width="100%" display="flex" flexDirection="column" className="overflowY">
                    {
                        record.data.list.map((v,k) => (
                            <Grid container bgcolor="#fff" display="flex" alignItems="center" borderBottom="1px solid #ddd" p={1} fontSize={14} key={k}>
                                <Grid item md={3} >
                                    <Box className="textOverFlow" textAlign="center">
                                        {moment(v.payment_date).format('MM/DD/YYYY')}
                                    </Box>
                                </Grid>
                                <Grid item md={3} >
                                    <Box className="textOverFlow" textAlign="center">
                                        {v.payment_reference_number}
                                    </Box>
                                </Grid>
                                <Grid item md={3} >
                                    <Box className="textOverFlow" textAlign="center">
                                        <Currency value= {v.total_paid_amount} displayType={'text'} thousandSeparator={true} prefix={''} />
                                    </Box>
                                </Grid>
                                <Grid item md={3} textAlign="center">
                                    <IconButton onClick={() => handlerView(v)}>
                                        <ViewIcon fill="#000"  stroke="#000" />
                                    </IconButton>
                                </Grid>
                            </Grid>
                        ))
                    }
                </Box>
            </Box>
            {
                openView.data &&
                    <View openView={openView} paidView={paidView} subdir={subdir} />
            }
        </Box>
    )
}
